import React, { Component } from 'react';
import UploadSuccessPlaceholder from './../../../assets/placeholders/upload_success.svg';
import {connect} from 'react-redux';
import * as actionCreators from './../../../modules/actions/index';


class UploadSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hierarchy: this.props.orgChart.temporaryHierarchy
    }
  }
    componentDidMount() {
    // console.log(this.props);
    // const {state} = this.props.location;
    // if(state) {
    //   this.setState({
    //     fromPage : this.props.location.state.fromPage
    //   })
    // }
  }

  componentDidMount=()=>{
    console.log(this.props, this.state)
    let{hierarchy}=this.state
    this.props.saveOfficeHierarchy(hierarchy);
    this.props.orgHierarchyChange(hierarchy)
    this.props.saveUpdatedOffices([])

  }

  goToUpload = ()=>{
    this.props.history.push('/home/upload-data')
  }

  render() {
    const {hierarchy} = this.state;
    console.log(this.props, this. state)
    return ( 
      <div className="text-center">
        <div className="mt60">
        <img src={UploadSuccessPlaceholder}/> : 

         {/* <img src={ManualUploadSuccessPlaceholder}/> */}
        </div>
        <div className="mt30">
        {/* /home/upload-data */}
          <span>
            Congratulations! You have successfully change your office names. 
            Please <span className="uploadLinkOfficeChange" onClick={this.goToUpload}> click here </span> to continue with
            your data upload.
          </span> 
          
          
        </div>
        
        
      
      
      
      
      </div>
    );
  }
}
 



const mapStateToProps = (state) => {
  console.log(state)
  return {
    user : state.user,
    orgChart:state.orgChart
  }
}



const mapDispatchToProps = dispatch => {
	return {
    saveOfficeHierarchy : (c) => dispatch(actionCreators.saveOfficeHierarchy(c)),
    orgHierarchyChange: (c) => dispatch(actionCreators.orgHierarchyChange(c)),
    saveUpdatedOffices: (updatedOffices) => dispatch(actionCreators.saveUpdatedOffices(updatedOffices)),

	}
}
 
export default connect(mapStateToProps,mapDispatchToProps)(UploadSuccess);